module.exports.getVersion = function() {
    if(window.config == null)
        return null;
    return window.config.version;
}

module.exports.getCopyright = function() {
    if(window.config == null)
        return null;
    return window.config.copyright;
}

module.exports.getTwitter = function() {
    if(window.config == null)
        return null;
    return window.config.twitter;
}

module.exports.getAppName = function() {
    if(window.config == null)
        return null;
    return window.config.appName;
}

module.exports.getSubTitle = function() {
    if(window.config == null)
        return null;
    return window.config.subTitle;
}

module.exports.getPrivacyURL = function() {
    if(window.config == null)
        return null;
    return window.config.privacyURL;
}

module.exports.getTermsURL = function() {
    if(window.config == null)
        return null;
    return window.config.termsURL;
}

module.exports.getCopyrightURL = function() {
    if(window.config == null)
        return null;
    return window.config.copyrightURL;
}

module.exports.getLicenseURL = function() {
    if(window.config == null)
        return null;
    return window.config.licenseURL;
}

module.exports.getTrickStratURL = function() {
    if(window.config == null)
        return null;
    return window.config.trickstratURL;
}

module.exports.getMaxStratCount = function() {
    if(window.config == null)
        return null;
    return window.config.maxStratCount;
}



// WEBPACK FOOTER //
// ./src/app/utils/config.js